import { ETheme, EThemeColor } from "@/common/entity/Enum";
import styled, { css } from "styled-components";

export const SectionResourcesWrapper = styled.div<{ $isSelected?: boolean, $theme?: string }>`
  width: 100%;
  height: 60px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    background-color: ${props => props.$theme === ETheme.Dark ? EThemeColor.ColorBrandBackground2HoverDark : EThemeColor.ColorBrandBackground2HoverLight};
  }

  ${(props) =>
    props.$isSelected &&
    css`
      margin-bottom: 8px;

      &:hover {
        background-color: ${props.$theme === ETheme.Dark ? EThemeColor.ColorBrandBackground2HoverDark : EThemeColor.ColorBrandBackground2HoverLight};
      }
    `};

    .mt_0 {
      margin-top: 0px !important;
    }
    .mb_4 {
      margin-bottom: 4px;
    }
    .custom_display_availabilityBox {
      display: flex;
      justify-content: flex-end;
      border-bottom: 1px solid;
      padding-bottom: 4px;
    }
`;

export const HeaderResourcesSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 16px;
`;

export const HeaderResourcesLeftWrapper = styled.div`
  width: 70%;
  display: flex;
  flex-direction: row;
`;

export const HeaderResourcesNameWrapper = styled.div`
  width: 100%;
  .label-text {
    text-align: left;
    font: var(--textstyleoutlook-bodysmall, 400 12px/16px "Segoe UI", sans-serif);
    margin-left: 8px;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    /* max-width: calc(100vw - 160px); */
     max-width: calc(100% - 30px);
  }
`;

export const HeaderResourcesRightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  top: 0px;
  padding-top: 0px !important;
  padding-right: 5px;

  &:hover {
    cursor: pointer;
  }
`;

export const HeaderResourcesLeft2Wrapper = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: ${props => props.$isSelected ? "70%" : "auto"};
  margin-top: ${props => props.$isSelected && "4px"};
`;

export const HeaderResourcesSection2Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 16px;
  margin-top: 4px;
`;

export const HeaderResourcesRight2Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  top: 0px;
  padding-right: 5px;
`;
